import { useState } from "react";
import { useTranslation } from "react-i18next";

import { Button } from "@aviary";
import { SvgFullscriptIcon, SvgFullscriptLogoDarkTextGreenLeaf } from "@shared/assets/logo";
import { useBreakpoints } from "@shared/hooks";
import { openCatalogRoutes } from "@unauthenticated/catalog/data/openCatalogRoutes";
import { l } from "@unauthenticated/catalog/locales/i18n";

import { Menu } from "../Menu";
import { Learn } from "../Menu/MenuItems/Learn";
import { Product } from "../Menu/MenuItems/Product";
import { Support } from "../Menu/MenuItems/Support/Support";
import { OpenNavigationContainer } from "../OpenNavigationContainer";

import * as styles from "./OpenCatalogNavigation.styles";

const OpenCatalogNavigation = () => {
  const { t } = useTranslation();
  const { tablet } = useBreakpoints();

  const [menuItem, setMenuItem] = useState<string>("");

  const setItem = (chosen: string) => {
    menuItem === chosen ? setMenuItem("") : setMenuItem(chosen);
  };

  const renderMenu = () => {
    if (menuItem !== "") {
      return (
        <div css={styles.dropdownBox}>
          {menuItem === t(l.navigation.OurPlatform) && <Product />}
          {menuItem === t(l.navigation.Learn) && <Learn />}
          {menuItem === t(l.navigation.Support) && <Support />}
        </div>
      );
    }
  };

  return (
    <OpenNavigationContainer>
      <nav css={styles.nav}>
        <ul css={styles.ul}>
          <li css={styles.navContainer}>
            <ul css={styles.ul}>
              <li>
                <Button
                  aria-label={t(l.navigation.FullscriptLogo)}
                  noStyle
                  css={styles.homeLink}
                  href={openCatalogRoutes.fullscript}
                >
                  {tablet.active || tablet.lessThan ? (
                    <SvgFullscriptIcon css={styles.navLogo} />
                  ) : (
                    <SvgFullscriptLogoDarkTextGreenLeaf css={styles.navLogo} />
                  )}
                </Button>
              </li>
              <li>
                <Menu
                  activeItem={menuItem}
                  setItem={setItem}
                  menuItem={t(l.navigation.OurPlatform)}
                />
              </li>
              <li>
                <Menu activeItem={menuItem} setItem={setItem} menuItem={t(l.navigation.Learn)} />
              </li>
              <li>
                <Menu activeItem={menuItem} setItem={setItem} menuItem={t(l.navigation.Support)} />
              </li>
            </ul>
          </li>
          <li css={styles.navContainer}>
            <ul css={styles.ul}>
              <li css={styles.signInButton}>
                <Button noStyle href={openCatalogRoutes.login}>
                  {t(l.navigation.SignIn)}
                </Button>
              </li>
              <li>
                <Button css={styles.navButton} isOutlined href={openCatalogRoutes.signUp}>
                  {t(l.navigation.CreateAccount)}
                </Button>
              </li>
            </ul>
          </li>
        </ul>
      </nav>
      {renderMenu()}
    </OpenNavigationContainer>
  );
};

export { OpenCatalogNavigation };
